export const Types = {

    GET_ROOT_CAUSE_FAMILY_AND_OPTIONS: "GET_ROOT_CAUSE_FAMILY_AND_OPTIONS",
    SET_ROOT_CAUSE_FAMILY_AND_OPTIONS: "SET_ROOT_CAUSE_FAMILY_AND_OPTIONS",

    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getRootCauseFamilyAndOptions = (payload) => ({
    type: Types.GET_ROOT_CAUSE_FAMILY_AND_OPTIONS,
    payload: payload,
});

export const setRootCauseFamilyAndOptions = (payload) => ({
    type: Types.SET_ROOT_CAUSE_FAMILY_AND_OPTIONS,
    payload: payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});